module.exports = __webpack_public_path__ + "static/media/2scr_728x90_red@2x.db4eb544.png";